import loadable from '@loadable/component';

export const LazyShop = loadable(() => import(/* webpackChunkName: "content/publicshop" */ './Shop'));
